import * as React from "react";

import { faTags } from "@fortawesome/free-solid-svg-icons";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { UseFormRegister, FormState } from "react-hook-form/dist/types";

import { FontAwesomeIconWithTheme } from "src/common/components/ui/IconWrapper";

const Heading = styled("div")(() => ({
  marginBottom: "25px",

  svg: {
    marginRight: "5px",
  },
}));

interface TagsFormProps {
  register: UseFormRegister<any>;
  formState: FormState<any>;
}

export const TagsInput: React.FC<TagsFormProps> = ({ register, formState }) => {
  return (
    <>
      <Heading>
        <Typography color="textPrimary" variant="h5">
          <FontAwesomeIconWithTheme icon={faTags} />
          Tags
        </Typography>
      </Heading>

      <TextField
        id="tags"
        label="Tags"
        multiline
        minRows="4"
        inputProps={{
          "data-testid": "workflow-tags",
        }}
        helperText={formState.errors?.tags ? "Valid JSON format string required" : '{"MyKey":"MyValue"}'}
        sx={{ width: "100%", marginBottom: "20px" }}
        {...register("tags")}
        error={formState.errors?.tags && true}
      />
    </>
  );
};
